import React, { createContext, useContext, useEffect, useState } from "react";
import { openDB } from "idb";
import {
  upgradeDB,
  seedStudios,
  seedArticles,
  seedPortfolios,
} from "./dbSetup";

const DB_VERSION = 1;
const DB_NAME = "LocalStudioDB";
const LOCAL_VERSION_KEY = "local_db_version";

const LocalDBContext = createContext();
export const useLocalDB = () => useContext(LocalDBContext);

export const LocalDBProvider = ({ children }) => {
  const [db, setDb] = useState(null);

  useEffect(() => {
    const init = async () => {
      const storedVersion = parseInt(localStorage.getItem(LOCAL_VERSION_KEY) || "0");

      if (storedVersion < DB_VERSION) {
        await resetDatabase();
        localStorage.setItem(LOCAL_VERSION_KEY, DB_VERSION.toString());
      } else {
        const existingDb = await openDB(DB_NAME, DB_VERSION);
        setDb(existingDb);
      }
    };

    init();
  }, []);

  const resetDatabase = async () => {
    const db = await openDB(DB_NAME, DB_VERSION, {
      upgrade(upgradeDb) {
        upgradeDB(upgradeDb);
      },
    });

    await seedStudios(db);
    await seedArticles(db);
    await seedPortfolios(db);

    setDb(db);
  };

  const getStudioById = async (id) => {
    if (!db) return null;
    return await db.get("studios", id);
  };

  const getArticlesByStudioId = async (studioId) => {
    if (!db) return [];
    const all = await db.getAll("articles");
    return all.filter((a) => a.studioId === studioId);
  };

  const getPortfoliosByStudioId = async (studioId) => {
    if (!db) return [];
    const all = await db.getAll("portfolios");
    return all.filter((p) => p.studioId === studioId);
  };

  const getAllStudios = async () => {
    if (!db) return [];
    return await db.getAll("studios");
  };  

  return (
    <LocalDBContext.Provider
      value={{
        getStudioById,
        getArticlesByStudioId,
        getPortfoliosByStudioId,
        getAllStudios,
      }}
    >
      {children}
    </LocalDBContext.Provider>
  );
};
